import { useState } from 'react';
import { FiMenu, FiMoon, FiSun, FiX } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import useThemeSwitcher from '../../hooks/useThemeSwitcher';
import HireMeModal from '../HireMeModal';
import logoDark from '../../images/logo-light.png';
import logoLight from '../../images/logo-light.png';
import { motion } from 'framer-motion';


const AppHeader = () => {
	const [showMenu, setShowMenu] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [activeTheme, setTheme] = useThemeSwitcher();

	function toggleMenu() {
		setShowMenu((prev) => !prev);
	}

	function closeMenu() {
		setShowMenu(false);
	}

	function showHireMeModal() {
		if (!showModal) {
			document
				.getElementsByTagName('html')[0]
				.classList.add('overflow-y-hidden');
			setShowModal(true);
		} else {
			document
				.getElementsByTagName('html')[0]
				.classList.remove('overflow-y-hidden');
			setShowModal(false);
		}
	}

	return (
		<motion.nav
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			id="nav"
			className="sm:container sm:mx-auto relative h-[var(--header-height)]"
		>
			<div className="z-50 max-w-screen-lg xl:max-w-screen-xl h-full flex justify-between items-center px-4 sm:px-0">
				{/* Logo */}
				<Link to="/" aria-label="Home">
					{activeTheme === 'dark' ? (
						<img
							src={logoDark}
							className="w-16"
							alt="Dark Logo"
						/>
					) : (
						<img
							src={logoLight}
							className="w-16"
							alt="Light Logo"
						/>
					)}
				</Link>

				{/* Header links large screen */}
				<div className="font-general-medium hidden m-0 sm:ml-4 mt-5 sm:mt-3 sm:flex p-5 sm:p-0 justify-center items-center shadow-lg sm:shadow-none">
					<Link
						to="/projects"
						className="block text-left text-lg text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light  sm:mx-4 mb-2 sm:py-2"
						aria-label="Projects"
					>
						Projects
					</Link>
					<Link
						to="/about"
						className="block text-left text-lg text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light  sm:mx-4 mb-2 sm:py-2"
						aria-label="About Me"
					>
						About Me
					</Link>
					<Link
						to="/contact"
						className="block text-left text-lg text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light  sm:mx-4 mb-2 sm:py-2"
						aria-label="Contact"
					>
						Contact
					</Link>
				</div>

				{/* Right side controls */}
				<div className="flex items-center">
					{/* Hire Me - large screen */}
					<div className="hidden md:flex mr-8">
						<span
							onClick={showHireMeModal}
							className="text-md font-general-medium bg-indigo-500 hover:bg-indigo-600 text-white shadow-sm rounded-md px-5 py-2.5 duration-300 cursor-pointer"
							aria-label="Hire Me Button"
						>
							Hire Me
						</span>
					</div>

					{/* Theme switcher */}
					<div
						onClick={() => setTheme(activeTheme)}
						aria-label="Theme Switcher"
						className="bg-primary-light dark:bg-ternary-dark p-3 shadow-sm rounded-xl cursor-pointer"
					>
						{activeTheme === 'dark' ? (
							<FiMoon className="text-ternary-dark hover:text-gray-400 dark:text-ternary-light dark:hover:text-primary-light text-xl" />
						) : (
							<FiSun className="text-gray-200 hover:text-gray-50 text-xl" />
						)}
					</div>

					{/* Hamburger - small screen */}
					<button
						onClick={toggleMenu}
						type="button"
						aria-label="Hamburger Menu"
						className="sm:hidden ml-3 bg-primary-light dark:bg-ternary-dark p-3 shadow-sm rounded-xl cursor-pointer focus:outline-none"
					>
						{showMenu ? (
							<FiX className="text-xl text-ternary-dark dark:text-ternary-light" />
						) : (
							<FiMenu className="text-xl text-ternary-dark dark:text-ternary-light" />
						)}
					</button>
				</div>
			</div>

			{/* Mobile menu dropdown */}
			{showMenu && (
				<div className="sm:hidden absolute top-[var(--header-height)] left-0 right-0 z-50 bg-secondary-light dark:bg-primary-dark px-4 pb-5 shadow-lg">
					<Link
						to="/projects"
						onClick={closeMenu}
						className="block text-left text-lg text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light py-3"
						aria-label="Projects"
					>
						Projects
					</Link>
					<Link
						to="/about"
						onClick={closeMenu}
						className="block text-left text-lg text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light py-3 border-t-2 border-primary-light dark:border-secondary-dark"
						aria-label="About Me"
					>
						About Me
					</Link>
					<Link
						to="/contact"
						onClick={closeMenu}
						className="block text-left text-lg text-primary-dark dark:text-ternary-light hover:text-secondary-dark dark:hover:text-secondary-light py-3 border-t-2 border-primary-light dark:border-secondary-dark"
						aria-label="Contact"
					>
						Contact
					</Link>
					<div className="pt-3 border-t-2 border-primary-light dark:border-secondary-dark">
						<span
							onClick={() => {
								closeMenu();
								showHireMeModal();
							}}
							className="font-general-medium block text-left text-md bg-indigo-500 hover:bg-indigo-600 text-white shadow-sm rounded-sm px-4 py-2 mt-2 duration-300 w-24 cursor-pointer"
							aria-label="Hire Me Button"
						>
							Hire Me
						</span>
					</div>
				</div>
			)}

			{/* Hire me modal */}
			<div>
				{showModal ? (
					<HireMeModal
						onClose={showHireMeModal}
						onRequest={showHireMeModal}
					/>
				) : null}
			</div>
		</motion.nav>
	);
};

export default AppHeader;
